module.exports = __webpack_public_path__ + "static/media/no-memento.dcfcec2a.png";